import firebase from 'firebase';
import user from "@/store/modules/user";

interface CloudMessaging {
  initialize() : Promise<void>;
  onMessage(messageCallback: firebase.NextFn<any> | firebase.Observer<any, Error>) : void;
}

class NullCloudMessaging implements CloudMessaging {
  initialize(): Promise<void> {
    throw new Error("Method not implemented.");
  }  
  
  onMessage(messageCallback: firebase.NextFn<any> | firebase.Observer<any, Error>): void {
    throw new Error("Method not implemented.");
  }
}

class FirebaseCloudMessaging implements CloudMessaging {
  
  messaging = firebase.messaging();
  token : string | null = null;

  constructor(vapidKey: string) {
    this.messaging.usePublicVapidKey(vapidKey);
  }

  requestPermissions() {
    return this.messaging.requestPermission();
  }

  async requestToken() {
    if (!this.token) {
      this.token = await this.messaging.getToken();
      this.storeToken(this.token);
    }
  }

  storeToken(token: string) {
    user.addAppToken(token);
    console.log("FCM App Token : ", token);
  }

  async initialize() {
    await this.requestPermissions();
    await this.requestToken();
    //this.messaging.onTokenRefresh()
    return Promise.resolve();
  }

  onMessage(messageCallback: firebase.NextFn<any> | firebase.Observer<any, Error>) {
    this.messaging.onMessage(messageCallback);
  }
}

let instance : CloudMessaging | null;

export function getCloudMessaging() : CloudMessaging {
  if (!instance) {
    if (firebase.messaging.isSupported()) {
      instance = new FirebaseCloudMessaging("BCcaf-LpzogPVgo4srgMVwt2U3v1FWamCecABLkvravzM4J_cD0iZz-ogq2KPfwdeO47f7YQck21cNfCE-FWLMs")
    } else {
      instance = new NullCloudMessaging();
    }
  }
  return instance; 
}



